// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
    let itemsMenuMob = document.querySelectorAll('.navigation.overlay ul li');

	if(itemsMenu){
		itemsMenu.forEach((itemMenu)=>{
			if(itemMenu.querySelector('.submenu')){
				let initialHeight = itemMenu.querySelector('.submenu').offsetHeight;
				if(!itemMenu.querySelector('.submenu:has(.active)')){
					itemMenu.addEventListener('mouseenter',()=>{
						itemMenu.classList.add('hover');
						itemMenu.querySelector('.submenu').classList.add('show');
						itemMenu.querySelector('.submenu').style.height = initialHeight + 'px';
					});
					itemMenu.addEventListener('mouseleave',()=>{
						itemMenu.classList.remove('hover');
						itemMenu.querySelector('.submenu').classList.remove('show');
						itemMenu.querySelector('.submenu').style.height = '0px';
					})
				}
				if (!itemMenu.querySelector('.submenu').classList.contains('show')){
					itemMenu.querySelector('.submenu').style.height = '0px';
				}
				if (itemMenu.querySelector('.submenu:has(.active)')){
					itemMenu.classList.add('hover');
					itemMenu.querySelector('.submenu').style.height = initialHeight + 'px';
				}
			}
		});
	}
	if(itemsMenuMob){
		itemsMenuMob.forEach((itemMenu)=>{
			if(itemMenu.querySelector('.submenu')){
				let initialHeight = itemMenu.querySelector('.submenu').offsetHeight;
				itemMenu.addEventListener('click', (e)=>{
					if(!itemMenu.classList.contains('hover')){
						e.preventDefault();
					}
					itemMenu.classList.add('hover');
					itemMenu.querySelector('.submenu').classList.add('show');
					itemMenu.querySelector('.submenu').style.height = initialHeight + 'px';
				})
				if (!itemMenu.querySelector('.submenu').classList.contains('show')){
					itemMenu.querySelector('.submenu').style.height = '0px';
				}
				if (itemMenu.querySelector('.submenu:has(.active)')){
					itemMenu.classList.add('hover');
					itemMenu.querySelector('.submenu').style.height = initialHeight + 'px';
				}
			}
		});
	}

	document.querySelectorAll('.js-menu-burger').forEach( menu => {
		menu.addEventListener('click', function(){
			document.querySelector('.main-nav').classList.toggle('open');
		});
	})

	
	if(document.querySelector('.js-menu-close')){
		document.querySelector('.js-menu-close').addEventListener('click', (e) => {
			e.preventDefault();
			document.querySelector('.main-nav').classList.toggle('open');
		});
	}

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

		//cms form focus animation
	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}
	if(document.querySelectorAll('.field').length > 0){
		document.querySelectorAll('.field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}

	let footerFormBtn = document.querySelector('#email-signup button[type=submit]');

	if(footerFormBtn){
		footerFormBtn.parentNode.querySelector('.fields-wrap').insertAdjacentElement('beforeend', footerFormBtn);
	}

	marginContainer();

	window.addEventListener('resize', ()=>{
		marginContainer();
	})

	let anchors = document.querySelectorAll('a');
	if(anchors){
		anchors.forEach( link => {
			link.addEventListener('click', function(e){
				if(link.getAttribute('href')){
					let currentTarget = link.getAttribute('href').split('#')[1];
					if( link.getAttribute('href').indexOf('#') === 0 ){
						e.preventDefault();
						let target = document.getElementById(currentTarget);
						if(target){
							if(!target.parentNode.classList.contains('lbx-container')){
								animateTo(target);
							}
						}
					}
				}
			})
			if( link.getAttribute('href')){
				if( link.getAttribute('href').indexOf('#') === 0 ){
					let currentTarget = link.getAttribute('href').split('#')[1];
					if( link.getAttribute('href').indexOf('#') === 0 ){
						let target = document.getElementById(currentTarget);
						if(target){
							if(target.parentNode.classList.contains('lbx-container')){
								link.setAttribute('data-lbx', '');
							}
						}
					}
				}
			}
		});
	}

	document.addEventListener("DOMContentLoaded", () => {
		if(window.innerWidth < 600){
			const main = document.querySelector("main");

			const lastSection = main.querySelector("section:last-of-type");

			if (lastSection) {
				lastSection.style.marginBottom = "65px";
			}
		}
	});

})();

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

function marginContainer(){
	let headerContainer = document.querySelector('.container');
	let wrapperContainer = document.querySelector('.wrapper');
	let marginLeftheader = window.getComputedStyle(headerContainer).marginLeft;
	let rightMarginWrapper = window.getComputedStyle(wrapperContainer).marginRight;
	let containerV2 = document.querySelectorAll('.container-v2');
	let wrapperV2 = document.querySelectorAll('.wrapper-v2');

	if(containerV2 && headerContainer){
		containerV2.forEach(each => {
			each.style.marginLeft = marginLeftheader;
		})
	}

	if(wrapperV2 && headerContainer){
		wrapperV2.forEach(each => {
			each.style.marginRight = rightMarginWrapper;
			each.style.marginLeft = marginLeftheader;
		})
	}
}

function animateTo(target, distance = null) {
	setTimeout(() => {
		//window.scrollTo(0, DOCUMENT_HEIGHT);
		
		var gotoTarget = offset(target).top;
		var from = window.pageYOffset || document.documentElement.scrollTop;

		var to = gotoTarget - 150;
		var duration = 1300;
		var start = new Date().getTime();
		//time interval
		var timer = setInterval(function () {
			var time = new Date().getTime() - start;

			if (from <= to) {
				var y = easeInOutQuart(time, from, to - from, duration);
			} else {
				var y = easeInOutQuart(time, from, -(from - to), duration);
			}
			window.scrollTo(0, y);
			if (time >= duration) clearInterval(timer);
		}, 1000 / 60);

		window.scrollTo(0, from);

	}, 300);
	
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(document.querySelector('body#gallery-flex')){
		document.getElementById('header').classList.add('down');
	}else{
		if(st > 80){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('down')){
					document.getElementById('header').classList.add('down');
					document.getElementById('header').classList.remove('up');
				}
			} else {
				// upscroll code
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
				}
			}
		} else {
			if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.remove('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}